/** An Element Show Event */
export default class Show extends CustomEvent {
    constructor(caller) {
        super('show', {
            bubbles: false,
            detail: {
                caller
            }
        });
    }
}
